import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { default as ButtonWrapper } from './Button';
import Container from './Container';
import Link from './Link';
export * from './types';

var isLink = function isLink(_ref) {
  var href = _ref.href;
  return !!href;
};

var isContainer = function isContainer(_ref2) {
  var buttonType = _ref2.buttonType;
  return buttonType === 'container';
};

var Button = function Button(_ref3) {
  var children = _ref3.children,
      _ref3$buttonType = _ref3.buttonType,
      buttonType = _ref3$buttonType === void 0 ? 'button' : _ref3$buttonType,
      props = _objectWithoutProperties(_ref3, ["children", "buttonType"]);

  var isReactNode = typeof children === 'object';

  var commonProps = _objectSpread(_objectSpread({
    buttonType: buttonType
  }, props), isReactNode ? {
    children: children
  } : {
    dangerouslySetInnerHTML: {
      __html: children
    }
  });

  if (isLink(props)) {
    return __jsx(Link, commonProps);
  }

  if (isContainer(_objectSpread(_objectSpread({}, props), {}, {
    buttonType: buttonType
  }))) {
    return __jsx(Container, commonProps);
  }

  return __jsx(ButtonWrapper, commonProps);
};

export default Button;